var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeachUmbrella2SvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#ffffff;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.122,277.312c6.042-4.619,14.559-9.533,24.352-13.986c17.625-8.093,39.242-15.003,58.458-19.751 c9.607-2.374,18.642-4.231,26.235-5.46c7.556-1.247,13.82-1.828,17.145-1.81h0.093l6.818,0.166l4.6-5.034 c16.018-17.515,31.667-27.104,43.103-32.37c5.709-2.633,10.365-4.176,13.451-5.034c1.552-0.425,2.698-0.684,3.4-0.822 c0.332-0.075,0.572-0.112,0.683-0.139l21.266-2.984l-10.217-18.956c-16.37-30.319-44.138-62.356-82.549-87.178 C347.566,59.16,298.365,41.802,240.184,41.82c-6.633,0-13.414,0.314-20.286,0.776l-2.495-16.037l-18.512,2.9l2.513,16 c-60.49,14.984-106.199,45.848-138.236,81.682c-16.758,18.725-29.838,38.78-39.612,58.688 c-9.754,19.908-16.203,39.676-19.621,57.986L0,264.989l21.098-3.64c0.075-0.009,2.624-0.397,7.132-0.397 c11.179,0.018,34.217,2.291,62.393,18.392l5.82,3.316l6.337-2.106c2.254-0.748,5.783-1.654,10.107-2.494 c13.062-2.568,33.33-4.629,55.058-4.61c21.93-0.028,45.561,2.106,65.182,7.288l27.935,178.485H38.947v26.216h471.962v-26.216 H287.593L259.122,277.312z M152.018,111.418c-22.336,32.378-37.894,67.547-48.018,96.203c-5.081,14.337-8.776,27.04-11.27,36.998 c-0.166,0.628-0.295,1.229-0.444,1.839c-21.856-10.3-40.96-14.005-54.54-15.086c3.104-10.42,7.316-21.339,12.712-32.351 c12.914-26.318,32.554-53.145,59.768-75.695c17.128-14.189,37.247-26.717,60.712-36.462 C164.157,94.754,157.857,102.984,152.018,111.418z M250.586,246.9L223.353,72.933c20.933,8.066,40.702,19.972,58.679,33.83 c29.358,22.596,53.987,50.198,71.649,73.422c7.686,10.115,14.061,19.4,18.938,27.039c-0.37,0.046-0.739,0.083-1.126,0.13 c-8.998,1.136-19.824,3.131-31.649,5.903c-17.718,4.148-37.543,10.004-55.982,17.33c-9.219,3.668-18.07,7.705-26.198,12.158 C255.223,244.093,252.877,245.487,250.586,246.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.445,
    y: 380.822,
    className: "st0",
    width: 49.404,
    height: 18.726
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.595,
    y: 380.822,
    className: "st0",
    width: 49.405,
    height: 18.726
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.57,
    y: 309.395,
    className: "st0",
    width: 49.404,
    height: 18.725
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "143.685,380.924 143.316,399.658 192.72,400.638 193.09,381.912 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "84.101,308.306 83.731,327.03 133.117,328.01 133.506,309.284 "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeachUmbrella2SvgrepoCom);
export default __webpack_public_path__ + "static/media/beach-umbrella-2-svgrepo-com.0f769ba4fee4b69b794cf10b901336a1.svg";
export { ForwardRef as ReactComponent };